/**
 * Colombian peso.
 */
export var COP = {
  code: 'COP',
  base: 10,
  exponent: 2
};